<template>
    <div v-show="!loading && !error" class="default-section job-card">
        <div v-for="profile in profiles" :key="profile" class="profile-bubble">
       
            <img :src="profileImage(profile.userId)" 
            :alt="profile.fullName" 
            :title="profile.fullName"
             @error="setDefaultImage"
             @click.stop="this.$router.push(`/org/${profile.handle}`)"
            class="profile-img"
            :class=" profile.totalVacancies > 0 ? 'has-jobs':''"/>
            <div v-if="profile.totalVacancies > 0" class="count">
                <BriefcaseJobIcon class="count-icon"/>
                <div class="count-number">{{ profile.totalVacancies }}</div>
            </div>
        </div>

        
    </div>
</template>
<script>
import { resolve } from 'croppie';
import BriefcaseJobIcon from './IconComponents/BriefcaseJobIcon.vue';
export default {
    components:{
        BriefcaseJobIcon
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            profiles: [],
            error: false,
            loading: true
        }
    },
  
    mounted(){
        this.getProfiles();
    },
    methods:{
        async getProfiles(){
            try{
            this.loading = true;
            let pageSize = 16;

            if(window.innerWidth <= 768){
                pageSize = 8;
            }
            var response = await fetch(`${this.url}Auth/NewProfiles?pageNumber=1&pageSize=${pageSize}`);
            this.loading = false;
            if(!response.ok){
                throw new Error();
            }else{
                var data = await response.json();
                this.profiles = data.profiles;
            }
            }catch(e){
                this.error = true;
            }
        },
        setDefaultImage(event) {
        event.target.src = require('@/assets/images/profile_picture.png');
        },
        profileImage(userId){
            if (userId == "" || userId == null) {
                return require('@/assets/images/profile_picture.png');
            }else{
                return this.url + 'Auth/Image/' + userId;
            }
        }
    }
    
     
    

}
</script>
<style scoped>

.default-section{
  /* margin:1.2rem 1rem; */
  margin:0rem 0rem!important;
}

.has-jobs{
    border:2px solid var(--green)!important;
}

.count-icon{
    height:0.7rem;
    margin-right:0.4rem;
    
}

.count-number{
    font-size:0.7rem;
}

.job-card {
      
    display: grid;
    grid-auto-flow: column;      
    grid-auto-columns: 4.5rem;     
    /*gap: 5px; */
    padding-top: 1.1rem;
    padding-bottom: 0.8rem;  
    padding-left: 0.7rem;  
    padding-right: 0.7rem; 
    /* border-radius: 8px; */
    margin-bottom: 0.5rem;
    /* margin-right:1rem; */
    max-width:100vw;
    /* background-color: var(--list-item); */
    background-color: var(--nav-glass);
    backdrop-filter: blur(8px);
    /* border-bottom: 1px solid var(--nav-border); */
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
}




.new-profiles::-webkit-scrollbar {
  display: none;
}

.count{
    position:absolute;
    background-color: var(--green);
    display:flex;
    align-items: center;
    flex-direction: row;
    color:var(--enterprise-button);
    padding:0rem 0.5rem;
    border-radius:50px;
    margin-top:2.6rem;
}

.name{
    font-family: var(--heading-font-bold);
    font-size:0.8rem;
    margin-top: 0.6rem;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    max-width:3rem;

}

.profile-bubble{
    flex: 0 0 auto; 
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top:-0.6rem;
    margin-right:0.7rem;
    flex-shrink: 0;
}

.profile-bubble:last-child{
     margin-right:0rem;
}

.profile-img{
    height:3.5rem;
    border:2px solid var(--background);
    border-radius:100px;
}
 

.listings-heading{
  margin: 0rem 0rem;
  color: var(--page-header);
  font-family:var(--page-header-font);
  font-size: 0.9rem;
}

/* Mobile overrides */
@media (max-width: 768px) {

  .listings-heading{
      margin:0.9rem 0rem;
      color: var(--page-header); 
      font-size: 1rem;
      font-weight: bold;
       font-family:var(--heading-font2-regular);
    }

    .profile-img{
        height:4rem;
    }

    .count{
        margin-top:3.3rem;
    }

    .job-card{
        padding-top: 1rem;
        padding-bottom: 0.7rem;
    }

 
}
</style>